import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="overlay_con">
      <div className="loader"></div>
    </div>
  );
};

export default LoadingSpinner;
